import { render, staticRenderFns } from "./tabContent.vue?vue&type=template&id=3df31392&scoped=true&"
import script from "./tabContent.vue?vue&type=script&lang=js&"
export * from "./tabContent.vue?vue&type=script&lang=js&"
import style0 from "./tabContent.vue?vue&type=style&index=0&id=3df31392&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df31392",
  null
  
)

export default component.exports